export enum ColumnAliasKey {
    REMITTANCES_ALL = "REMITTANCES_ALL",
    INCOMPLETE_REMITTANCES = "INCOMPLETE_REMITTANCES",
    REMITTANCE_ITEMS_ALL = "REMITTANCE_ITEMS_ALL",
    INCOMPLETE_REMITTANCE_ITEMS = "INCOMPLETE_REMITTANCE_ITEMS",
  }